/**
 * 章节管理 API（双栈适配）
 */
import apiClient from '../client'
import { unwrapData, unwrapList, mapPythonChapter, type TableDataInfo } from '../responseAdapter'
import { textbookApiPrefix } from './basePath'

export interface Chapter {
  chapterId: number
  textbookId: number
  chapterNumber: number
  title: string
  contentId?: string
  status: string
  wordCount?: number
  createBy?: string
  createTime?: string
  updateBy?: string
  updateTime?: string
  remark?: string
}

function prefix() {
  return textbookApiPrefix()
}

/** 查询章节列表（分页） */
export async function listChapter(params?: {
  pageNum?: number
  pageSize?: number
  textbookId?: number
  title?: string
  status?: string
}): Promise<TableDataInfo<Chapter>> {
  const response = await apiClient.get(`${prefix()}/chapters/list`, { params })
  const { rows, total } = unwrapList<Record<string, unknown>>(response)
  return {
    code: 200,
    msg: 'success',
    total,
    rows: rows.map((r) => mapPythonChapter(r) as Chapter),
  }
}

/** 根据教材ID查询章节列表 */
export async function listChapterByTextbook(textbookId: number): Promise<{ data: Chapter[] }> {
  const response = await apiClient.get(`${prefix()}/chapters/textbook/${textbookId}`)
  const list = unwrapData<Record<string, unknown>[]>(response)
  const chapters = (Array.isArray(list) ? list : []).map(
    (r) => mapPythonChapter(r) as Chapter
  )
  return { data: chapters }
}

/** 获取章节详情 */
export async function getChapter(chapterId: number) {
  const response = await apiClient.get(`${prefix()}/chapters/${chapterId}`)
  return { data: mapPythonChapter(unwrapData<Record<string, unknown>>(response)) as Chapter }
}

/** 新增章节 */
export function addChapter(data: Partial<Chapter>) {
  const body = {
    textbook_id: data.textbookId,
    chapter_number: data.chapterNumber,
    title: data.title,
    content: '',
  }
  return apiClient.post(`${prefix()}/chapters`, body)
}

/** 修改章节 */
export function updateChapter(data: Partial<Chapter> & { chapterId: number }) {
  return apiClient.put(`${prefix()}/chapters`, data)
}

/** 删除章节 */
export function delChapter(chapterId: number) {
  return apiClient.delete(`${prefix()}/chapters/${chapterId}`)
}

/** 提交章节审核 */
export function submitChapter(chapterId: number) {
  return apiClient.post(`${prefix()}/chapters/${chapterId}/submit`)
}

/** 审核章节 */
export function reviewChapter(
  chapterId: number,
  data: { status: 'approved' | 'rejected' | 'pending'; comment?: string }
) {
  return apiClient.post(`${prefix()}/chapters/${chapterId}/review`, data)
}

/** 发布章节 */
export function publishChapter(chapterId: number) {
  return apiClient.post(`${prefix()}/chapters/${chapterId}/publish`)
}
